import { Request } from "@henrotaym/api-client";
import { JsonCredential } from "@henrotaym/api-client";
import setup from "../../setup";

/**
 * Credential preparing request to trustup pro auth api.
 */
class TrustupProCredential extends JsonCredential
{
    /**
     * Preparing given request.
     * @param {Request<any>} request
     * @returns {void}
     */
    prepare(request) {
        super.prepare(request);
        request.setBaseUrl(`${setup.auth_url}/api`)
            .withCredentials(true)
    }
}

export default TrustupProCredential;